import { ref } from 'vue';
import { directUpload, getUploadConfig } from '@/request/common';
import { getToken } from '@/api';

const baseApi = process.env.VUE_APP_API_BASE_URL;
const headers = {
  Authorization: getToken(),
};

export function useImageScreenshotData() {
  const getFormattedCurrentTime = () => {
    const now = new Date();
    return `${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, '0')}${now
      .getDate()
      .toString()
      .padStart(2, '0')}${now.getHours().toString().padStart(2, '0')}${now.getMinutes().toString().padStart(2, '0')}${now
      .getSeconds()
      .toString()
      .padStart(2, '0')}`;
  };

  const downloadImageFn = (dom) => {
    let timestamp = getFormattedCurrentTime();
    const dataURL = dom.toDataURL('image/png');
    const link = document.createElement('a');
    link.href = dataURL;
    link.download = `screenshots_${timestamp}.png`;
    link.click();
  };
  const getImageFn = (dom) => {
    let timestamp = getFormattedCurrentTime();
    const dataURL = dom.toDataURL('image/png');
    return dataURL;
  };

  const getImageDataFn = (dom) => {
    let timestamp = getFormattedCurrentTime();

    return new Promise((resolve, reject) => {
      dom.toBlob((blob) => {
        if (blob) {
          const file = new File([blob], `screenshots_${timestamp}.png`, { type: 'image/png' });
          resolve(file);
        } else {
          reject(new Error('Failed to create blob from canvas'));
        }
      }, 'image/png');
    });
  };

  const handleCustomUpload = async (file) => {
    try {
      const uploadConfigRes = await getUploadConfig(file);
      const { code: uploadConfigCode, data: uploadConfigData } = uploadConfigRes.data;

      if (uploadConfigCode !== 200) {
        return Promise.reject(uploadConfigRes.data.msg);
      }

      const { presignedUrl, url } = uploadConfigData;
      const uploadRes = await directUpload(presignedUrl, file);

      return {
        code: uploadRes.status,
        data: {
          ...uploadRes.data,
          url: url,
          originalFilename: file.name,
        },
      };
    } catch (error) {
      return Promise.reject(error);
    }
  };

  const uploadDomImage = async (dom) => {
    try {
      const file = await getImageDataFn(dom);
      const uploadResponse = await handleCustomUpload(file);
      return uploadResponse;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  return { downloadImageFn, getImageDataFn, handleCustomUpload, uploadDomImage, getImageFn };
}
